<rt-dialog-body variant="white">
  <div layout-vertical layout-full-width>
    <div layout layout-justify-center>
      <div class="img-wrap">
        <img src="{{ imageSrc }}" alt="" />
      </div>
    </div>
    <div class="text-wrap" layout-vertical layout-align-items-center>
      <rt-heading variant="heading large-xx" text-center margin-bottom-small-xx>
        {{ translations.heading }}
      </rt-heading>
      <div class="text">
        <div [innerHTML]="translations.description" class="description"></div>
      </div>
    </div>
  </div>
</rt-dialog-body>

<div class="footer" layout-centered-x>
  <div layout padding>
    <rt-button (click)="close()" variant="plain" margin-right-small>
      {{ translations.cancel }}
    </rt-button>
    <rt-button (click)="onCtaButtonClick()" variant="primary">
      {{ isInternalJob ? translations.viewJobsPipeline : translations.promoteJob }}
    </rt-button>
  </div>
</div>
